import type { ReactNode } from 'react'
import React from 'react'

import type { IDropDownProps } from '../DropDown'
import DropDown from '../DropDown'

type ITooltip = Omit<IDropDownProps, 'type' | 'children'> & { children: ReactNode }

const Tooltip: React.FC<ITooltip> = ({ children, overlay, ...restProps }) =>
  !overlay ? (
    children
  ) : (
    <DropDown {...restProps} overlay={overlay} type='tooltip'>
      {children}
    </DropDown>
  )

export default Tooltip
